import { combineReducers } from "redux";
import local from "./localReducer";
import app from "./appReducer";

export const rootReducer = combineReducers({
    local,
    app,
});
